import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import {
  IDeltaHedgeExeCommonSearchParam,
  IDeltaReport,
} from "../../Interfaces/deltaHedgeExe";
import { getDeltaTable } from "../../Requests/deltaHedgeExe";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}

const DeltaTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, IDeltaReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getDeltaTable}
      searchParameters={searchParams}
      refreshTableTime={5000}
    />
  );
};

export default DeltaTable;
